module.exports = __webpack_public_path__ + "img/nepaliport_logo.a57ef354.png";